globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.Loader = (function() {

  function Loader() {}

  /* Exemples
  *
  * Loader.start();                               -> Body loading
  * Loader.start({$container: $some_object})      -> Zone loading
  *
  * Loader.set({ options: {text: "Loaded content, access to page..."} }) -> Update current loader
  *
  * Loader.stop();                                -> Body loaded
  * Loader.stop({$container: $some_object});      -> Zone loaded
  *
  * Loader.start({ options: {text: "Loading..."} })
  * Loader.start({ options: {style: { spinner: { color: 'red' }} })
  *
  * Loader.error({ options: {text: "An error occured."} })
  *
  * Loader.success({ options: {text: "Done!"} })
  */

  /* Options - all options can be overwritted (see above) */
  Loader.options = {
    text: appCustomerSpace.lang.t('commons.waiting'),
    spinner: true,
    error: {
      persisted: false,
      timeOut: 2000
    },
    success: {
      persisted: false,
      timeOut: 2000
    },
    icon_size: '2x',
    classes: {
      loader: 'loader',
      loading: 'loading'
    },
    style: {
      backdrop: {
        position: 'absolute',
        zIndex: 1500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        height: '100%',
        top: 0, right: 0,
        left: 0, bottom: 0,
        background: '#eff5fe',
        cursor: 'wait'
      },
      spinner: {
        marginBottom: '10px'
      },
      error: {
        color: 'rgb(194,28,52)',
        marginBottom: '10px'
      },
      success: {
        color: 'rgb(34,139,34)',
        marginBottom: '10px'
      },
      text: {
        fontSize: '14px'
      }
    }
  };


  /* Public methods */

  Loader.start = function({ $container = Loader._$default_container(), options = {} } = {}) {
    var options = utils.mergeDeep(Loader.options, options);
    Loader._start($container, options);
  };

  Loader.stop = function({ $container = Loader._$default_container() } = {}, callback) {
    Loader._stop($container, callback);
  };

  Loader.error = function({ $container = Loader._$default_container(), options = {} } = {}, callback) {
    var options = utils.mergeDeep(Loader.options, options);
    Loader._error($container, options, callback);
  };

  Loader.success = function({ $container = Loader._$default_container(), options = {} } = {}, callback) {
    var options = utils.mergeDeep(Loader.options, options);
    Loader._success($container, options, callback);
  };

  Loader.set = function({ $container = Loader._$default_container(), options = {} } = {}, callback) {
    var options = utils.mergeDeep(Loader.options, options);
    Loader._set($container, options, callback);
  };

  /* Private methods */

  Loader._$default_container = function() {
    return $('body');
  }

  Loader._closestParentLoaderZIndex = function($container, loaderClass) {
    if(!$container || !$container.length) return null;

    var $parent = $container.parent();
    while($parent && $parent.length) {
      var $parentLoader = $parent.children('.' + loaderClass).first();
      if($parentLoader.length) {
        var z = parseInt($parentLoader.css('z-index'), 10);
        if(!isNaN(z)) return z;
      }
      $parent = $parent.parent();
    }

    return null;
  };

  Loader._applyHierarchyZIndex = function($container, $loader, options) {
    if(!$loader || !$loader.length) return;

    var fallbackZ = options.style.backdrop.zIndex;
    fallbackZ = parseInt(fallbackZ, 10);
    if(isNaN(fallbackZ)) fallbackZ = 1500;

    var zIndex = fallbackZ;

    var parentZ = Loader._closestParentLoaderZIndex($container, options.classes.loader);
    if(parentZ != null) zIndex = parentZ - 1;

    if(zIndex < 0) zIndex = 0;

    $loader.css({ zIndex: zIndex });
  };

  Loader._start = function($object, options) {
    if($object.find('.' + options.classes.loader).length) return;
    if($object.is(Loader._$default_container())) {
      utils.mergeDeep(options, {
        style: {
          backdrop: {
            position: 'fixed'
          }
        }
      })
    } else {
      var basePosition = $object.css('position');

      if(!['absolute', 'fixed'].includes(basePosition)) {
        $object.data('css-base-position', basePosition).css({ position: 'relative' });
      }
    }

    options.style.backdrop.top = 0 + $object.scrollTop() + 'px';

    var $loader = Loader._$template(options).prependTo($object);
    Loader._applyHierarchyZIndex($object, $loader, options);
    $object.addClass(Loader.options.classes.loading);
  };

  Loader._stop = function($object, callback) {
    $object.find('.' + Loader.options.classes.loader).fadeOut(200, function(){
      $(this).remove();

      if(!$object.is(Loader._$default_container()) && $object.data('css-base-position') != undefined) {
        $object.css({ position: $object.data('css-base-position') }).data('css-base-position', null);
      }

      $object.removeClass(Loader.options.classes.loading);
      if(typeof callback == 'function') callback();
    });
  };

  Loader._error = function($object, options, callback) {
    utils.mergeDeep(options, {
      spinner: false,
      displayErrorIcon: true,
      style: {
        backdrop: {
          cursor: 'default'
        }
      }
    });

    if($object.is(Loader._$default_container())) {
      utils.mergeDeep(options, {
        style: {
          backdrop: {
            position: 'fixed'
          }
        }
      });
    }

    var $loading_template = $object.find('.' + Loader.options.classes.loader),
        $error_template = Loader._$template(options);

    if($loading_template.length) {
      $loading_template.replaceWith($error_template);
      Loader._applyHierarchyZIndex($object, $error_template, options);
      if(!Loader.options.error.persisted) {
        setTimeout(function(){
          $error_template.fadeOut(200, function(){
            $error_template.remove();
            $object.removeClass(Loader.options.classes.loading);
            if(typeof callback == 'function') callback();
          })
        }, Loader.options.error.timeOut)
      }
    }
  };

  Loader._success = function($object, options, callback) {
    utils.mergeDeep(options, {
      spinner: false,
      displaySuccessIcon: true,
      success: { persisted: true },
      style: {
        backdrop: {
          cursor: 'default'
        }
      }
    });

    if($object.is(Loader._$default_container())) {
      utils.mergeDeep(options, {
        style: {
          backdrop: {
            position: 'fixed'
          }
        }
      });
    }

    var $loading_template = $object.find('.' + Loader.options.classes.loader),
        $success_template = Loader._$template(options);

    if($loading_template.length) {
      $loading_template.replaceWith($success_template);
      Loader._applyHierarchyZIndex($object, $success_template, options);
      if(!options.success.persisted) {
        setTimeout(function(){
          $success_template.fadeOut(200, function(){
            $success_template.remove();
            $object.removeClass(Loader.options.classes.loading);
            if(typeof callback == 'function') callback();
          })
        }, options.success.timeOut)
      }
    }
  };

  Loader._set = function($object, options, callback) {
    if($object.is(Loader._$default_container())) {
      utils.mergeDeep(options, {
        style: {
          backdrop: {
            position: 'fixed'
          }
        }
      });
    }

    var $loading_template = $object.find('.' + Loader.options.classes.loader),
        $new_template = Loader._$template(options);

    if($loading_template.length) {
      $loading_template.replaceWith($new_template);
      Loader._applyHierarchyZIndex($object, $new_template, options);
      if(typeof callback == 'function') callback();
    }
  };

  Loader._$spinner = function(size, marginBottom) {
    var width, height;

    switch(size) {
      case '1x':
        width   = 20;
        height  = 20;
        break;
      case '2x':
        width   = 50;
        height  = 50;
        break;
      case '3x':
        width   = 75;
        height  = 75;
        break;
    }

    return $('\
      <svg version="1.1" height="'+height+'" width="'+width+'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 701.6 701.6" style="margin:0 auto '+marginBottom+' auto;enable-background:new 0 0 701.6 701.6;" xml:space="preserve">\
        <style type="text/css">\
          .st0{fill:#d7e2f3;}\
          .st1{fill:#3333FF;}\
          @keyframes rotate {\
              from { transform: rotate(0deg); }\
              to { transform: rotate(360deg); }\
          }\
          #progress {\
            animation: rotate 0.8s linear infinite;\
            transform-origin: center center;\
          }\
        </style>\
        <g>\
          <g>\
            <path class="st0" d="M222.3,587.5c-86.4-45.1-145.4-134-145.4-236.4c0-3.2,0.1-6.4,0.2-9.6c10.1,6.5,20.7,12.3,31.7,17.3 c19.6,9,39.6,17.2,59.9,24.5c20.4,7.4,40.4,14.6,60,21.7c19.6,7.1,37.1,15,52.4,23.7c15.3,8.7,27.7,18.9,37.2,30.5 c9.4,11.7,14.2,25.7,14.2,42.3c0,17.1-3.2,31.6-9.5,43.6c-6,11.5-14.5,21.5-25,29.2c-10.5,7.6-22.4,13.3-35,16.6 C263.1,591,241.9,597.7,222.3,587.5z"/>\
            <path class="st0" d="M406,247.8h-88.1c-1.9-0.6-3.2-2.3-3.4-4.2c-1.9-16.4-5.5-31.3-11.4-44.2c-6.3-14-14.8-25.8-25.2-35.3 c-10.6-9.5-23-16.8-36.5-21.5c-13.9-4.9-28.9-7.3-45.1-7.3c-5.1-0.1-10.1,1.7-14,5c-32.1,24.6-57.9,56.3-76.8,92 c-3.7,6.9-0.4,12.1-0.4,12.1c2,4.2,4.3,8.1,7.1,11.7c9.4,12.4,21.8,23.2,37,32.3c15.2,9.1,32.6,17.2,52.2,24.3 c19.6,7.1,39.7,14.2,60.2,21.5c20.5,7.2,40.6,15.1,60.2,23.7c19.6,8.6,37,19,52.2,31.2c15,12,27.6,26.8,37,43.6 c9.4,16.8,14.2,37,14.2,60.6c0,27.7-4.9,52.1-14.8,73c-9.5,20.4-23.8,38.2-41.5,52c142.9-9,256-125.1,256-267.1 c0-147.9-122.6-267.7-273.9-267.7c-18.2,0-36.3,1.8-54.1,5.2c24.9,10.9,45.5,24.7,61.7,41.5c16.7,17.3,29.1,36.3,37.2,57.1 c7.5,19.2,12,37.9,13.6,55.7C409.2,242.9,410.4,247.8,406,247.8z"/>\
          </g>\
          <path class="st0" d="M350.8,0C157.1,0,0,157.1,0,350.8s157.1,350.8,350.8,350.8s350.8-157.1,350.8-350.8S544.6,0,350.8,0z M350.8,672.4c-177.6,0-321.6-144-321.6-321.6s144-321.6,321.6-321.6s321.6,144,321.6,321.6S528.4,672.4,350.8,672.4z"/>\
        </g>\
        <path id="progress" class="st1" d="M29.2,350.8c0-177.6,144-321.6,321.6-321.6V0C157.1,0,0,157.1,0,350.8H29.2z"/>\
      </svg>');
  }

  Loader._$template = function(options) {
    var $template = $('<div class="' + options.classes.loader + '">').css(options.style.backdrop),
        $element   = $('<div>');

    if(options.spinner) {
      if(global_options.tech_provider_loader) {
        $element.append(Loader._$spinner(options.icon_size, options.style.spinner.marginBottom)).css(options.style.spinner);
      } else {
        $element.append($('<i class="fa fa-spinner fa-pulse fa-'+ options.icon_size +'">').css(options.style.spinner));
      }
    }
    if(options.displayErrorIcon || (options.error && options.error.persisted)) $element.append($('<i class="fa fa-times fa-'+ options.icon_size +'">').css(options.style.error));
    if(options.displaySuccessIcon || (options.success && options.success.persisted)) $element.append($('<i class="fa fa-check fa-'+ options.icon_size +'">').css(options.style.success));
    if(options.text)    $element.append($('<div>' + options.text + '</div>').css(options.style.text));

    $element.appendTo($template);

    return $template;
  };

  return Loader;
});
